import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React, { useState } from 'react'

import { PermissionChecker } from '../../session'
import { VIEWS } from '../_shared/ViewToggle'
import { getLocalStorageItem, useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import AvailabilityKanban from '../kanban/AvailabilityKanban'
import AvailabilityTable from './table/AvailabilityTable'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import OpenNonCompliancesCountsLoader from './_load/OpenNonCompliancesCountsLoader'
import PageHeader from './PageHeader'
import PlacesAvailabilityLoader from './_load/PlacesAvailabilityLoader'
import Separator from '../../../components/helpers/Separator'

// Same "remember last view" pattern used by Service Orders (`LAST_PROCESS_VIEW_MODE` /
// `SERVICE_ORDERS_LAST_SCREEN`, see `utils/helpers/localStorage.js`), adapted for a single
// page that toggles views locally instead of navigating between routes.
const AVAILABILITY_LAST_VIEW_MODE = 'AVAILABILITY_LAST_VIEW_MODE'

const AvailabilityPage = () => {
  const [view, setView] = useState(() => getLocalStorageItem(AVAILABILITY_LAST_VIEW_MODE) || VIEWS.LIST)
  useLocalStorageWatcher(AVAILABILITY_LAST_VIEW_MODE, view)

  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="useAvailabilityPanel">
        <Container>
          <FilterHandler tempStorageNamespace="placeAvailability">
            <PageHeader />
            <ControlBar view={view} setView={setView} />

            <PlacesAvailabilityLoader>
              <OpenNonCompliancesCountsLoader>
                {view === VIEWS.KANBAN ? <AvailabilityKanban /> : <AvailabilityTable />}
              </OpenNonCompliancesCountsLoader>
            </PlacesAvailabilityLoader>
          </FilterHandler>
          <Separator weight={32} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default AvailabilityPage
